import {IHttpService} from "angular";
import {AveragePriceUpdateRequest} from "../types/AveragePriceUpdateRequest";
import {encodeSecurity} from "../../instruments/types/CodeAndExchange";
import {EquityAccountId} from "../equity/types/EquityAccountRecord";
import {EquityPositionRecords} from "../equity/types/EquityPositionRecord";
import {PendingAveragePriceUpdateRecords} from "../types/PendingAveragePriceUpdateRecord";

export class AveragePriceUpdateRequestService {

    public static id = "averagePriceUpdateRequestService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async requestAveragePriceUpdate(averagePriceUpdateRequest: AveragePriceUpdateRequest) {
        const accountId = averagePriceUpdateRequest.accountId;
        const security = encodeSecurity(averagePriceUpdateRequest);
        const averagePriceUpdate = averagePriceUpdateRequest.averagePriceUpdate;
        const url = `/tradefloor/api/om/average-price-update/${accountId}/${security}`;

        await this.$http.post(url, averagePriceUpdate);
    }

    public async getPendingAveragePriceUpdates(accountId: EquityAccountId): Promise<PendingAveragePriceUpdateRecords> {
        const url = `/tradefloor/api/om/average-price-update/${accountId}/`;
        const response = await this.$http.get<PendingAveragePriceUpdateRecords>(url);
        return response.data;
    }
}

